// Utils
import { assert, isObject } from 'ezyvet-fe-helpers';
import { attachGeneratedObjectIdToObjectRecursivelyOrReturn } from './attachGeneratedObjectIdToObjectRecursivelyOrReturn';
/**
 * @description Attaches unique generated identifiers to the given object and any nested objects if missing, if the given object and all nested objects already have identifiers, the given object is returned.
 * @throws {Error} if an value other than an object is given.
 *
 * @template T
 * @param {T} values
 *
 * @return T
 */
export var attachGeneratedObjectIdRecursivelyOrReturn = function (values) {
    assert(isObject(values), 'method requires an object to identify');
    return attachGeneratedObjectIdToObjectRecursivelyOrReturn(values);
};
//# sourceMappingURL=attachGeneratedObjectIdRecursivelyOrReturn.js.map